module.exports = __webpack_public_path__ + "static/img/fish2.2a764bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jingdianfish/fish2.png
// module id = BsP/
// module chunks = 0